angular.module('impactx.orderconfiguration').controller('ComplaintConfigurationCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'BackService',
    'ToastService',
    'ToolbarService',
    ComplaintConfigurationCtrl]);

function ComplaintConfigurationCtrl($scope, dataGen, $routeParams, BackService, ToastService, ToolbarService) {
    var self = this;
    self.save = function () {
        if ($scope.data) {
            var dataToSave = $scope.data;

            //Reduce data which will be sent to server.
            dataToSave.companies = dataGen.slimDownPopup(dataToSave.companies);

            return dataGen.postAsForm($scope, {data: dataToSave}, "/complaintconfiguration/save").then(function () {

                BackService.back();
                ToastService.openStandardToast($scope.trns.saveSuccess);
            });
        }
    };

    self.delete = function () {

        return dataGen.postAsForm($scope, {id: $scope.data.id}, "/complaintconfiguration/delete").then(function () {

            BackService.back();
            ToastService.openStandardToast($scope.trns.deleteSuccess);
        });
    };

    dataGen.getData($scope, {id: $routeParams.id}, "/complaintconfiguration/view").then(function () {
        defineButtons();
    });

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: self.save,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.delete,
                action: self.delete,
                type: 'dialogaction',
                condition: canDelete
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return $scope.data.canEdit && !$scope.data.readOnly;
    }

    function canDelete() {
        return $scope.data.canDelete && !$scope.data.readOnly && $scope.data.id > 0;
    }
}